// frontend/src/components/QuoteManager.js
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadQuotes, addQuote, updateQuote, deleteQuote } from '../redux/slices/tradingSlice';
import { FaPlus, FaEdit, FaTrash, FaSave, FaTimes } from 'react-icons/fa';
import toast from 'react-hot-toast';

const QuoteManager = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { quotes } = useSelector((state) => state.trading);
  const [newQuote, setNewQuote] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editingText, setEditingText] = useState('');

  useEffect(() => {
    if (user?.uid) {
      dispatch(loadQuotes(user.uid));
    }
  }, [user]);

  const handleAddQuote = async () => {
    if (!newQuote.trim()) {
      toast.error('Please enter a quote');
      return;
    }
    const success = await dispatch(addQuote(user.uid, newQuote.trim()));
    if (success) {
      setNewQuote('');
    }
  };

  const handleUpdateQuote = async (id) => {
    if (!editingText.trim()) {
      toast.error('Please enter a quote');
      return;
    }
    const success = await dispatch(updateQuote(user.uid, id, editingText.trim()));
    if (success) {
      setEditingId(null);
      setEditingText('');
    }
  };

  const handleDeleteQuote = async (id) => {
    if (window.confirm('Delete this motivational quote?')) {
      await dispatch(deleteQuote(user.uid, id));
    }
  };

  const startEdit = (quote) => {
    setEditingId(quote.id);
    setEditingText(quote.text);
  };

  const cancelEdit = () => {
    setEditingId(null);
    setEditingText('');
  };

  return (
    <div className="quote-manager">
      <div className="form-group">
        <label>Add New Motivational Quote</label>
        <div className="add-quote-form">
          <input
            type="text"
            value={newQuote}
            onChange={(e) => setNewQuote(e.target.value)}
            placeholder="Enter a motivational quote..."
            className="quote-input"
          />
          <button onClick={handleAddQuote} className="btn btn-primary">
            <FaPlus /> Add Quote
          </button>
        </div>
      </div>
      
      <div className="quotes-list">
        <h3>Your Quotes ({quotes.length})</h3>
        {quotes.length === 0 ? (
          <p className="text-muted">No quotes added yet. Add your first motivational quote above.</p>
        ) : (
          <div className="quotes-grid">
            {quotes.map(quote => (
              <div key={quote.id} className="quote-card">
                {editingId === quote.id ? (
                  <div className="quote-edit">
                    <textarea
                      value={editingText}
                      onChange={(e) => setEditingText(e.target.value)}
                      rows={3}
                    />
                    <div className="quote-edit-buttons">
                      <button onClick={() => handleUpdateQuote(quote.id)} className="btn-success btn-small">
                        <FaSave /> Save
                      </button>
                      <button onClick={cancelEdit} className="btn-secondary btn-small">
                        <FaTimes /> Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  <>
                    <p className="quote-text">"{quote.text}"</p>
                    <div className="quote-actions">
                      <button onClick={() => startEdit(quote)} className="edit-btn" title="Edit">
                        <FaEdit />
                      </button>
                      <button onClick={() => handleDeleteQuote(quote.id)} className="delete-btn" title="Delete">
                        <FaTrash />
                      </button>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default QuoteManager;